export default (value: string | number) => {
  const stringValue = value.toString().trim();

  const normalized = stringValue.toLowerCase().endsWith("px")
    ? stringValue.slice(0, -2)
    : stringValue;

  const pixel = Number(normalized);
  if (!Number.isFinite(pixel)) {
    throw new TypeError(
      `pixelToRem: value must be a numeric pixel value: ${value}, ${pixel}`,
    );
  }

  const rem = pixel / 16;
  return `${rem}rem`;
};
